import gql from 'graphql-tag';

import type { TextAnnotationMap } from 'src/data/annotation';
import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationExtractTextAnnotationsArgs } from 'src/types/backend';

import { FRAGMENT_TEXT_ANNOTATIONS } from './schema';

const MUTATION = gql`
  mutation ExtractTextAnnotations(
    $customerId: ID!
    $generationTool: GenerationToolEnum!
    $text: String!
    $variationId: ID
    $productName: String
  ) {
    extractTextAnnotations(
      customerId: $customerId
      generationTool: $generationTool
      text: $text
      variationId: $variationId
      productName: $productName
    ) {
      ...TextAnnotations
    }
  }
  ${FRAGMENT_TEXT_ANNOTATIONS}
`;

type Variables = BackendMutationExtractTextAnnotationsArgs;

export const extractTextAnnotations = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
): Promise<TextAnnotationMap | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...variables,
      productName: variables.productName ?? null,
    },
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<TextAnnotationMap>(result.data);
};
